export default __webpack_public_path__ + "static/media/auto-fill-dots.284c0e36.svg";